import { Button, Paper } from "@mui/material";
import { addUserApi } from "API/apis/admin/users/addUser";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { FormModal } from "components/ModalForm/ModalForForm";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import { useUsersContext } from "../context";

import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { DeptSelector } from "components/SearchSelect/DeptSelector";
import { SearchUsers } from "components/SearchSelect/SearchUsers";

const initialUserDetail = {
  name: "",
  dept: "",
  subDept: "",
  userId: "",
};

const initialState = {
  username: "",
  ievoCode: 0,
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  companyIds: [],
  deptId: 0,
  mgrUserId: "",
};

export const AddUserFormModal = ({ openModal, setOpenModal }) => {
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const { isReloadRequired, setIsReloadRequired } = useUsersContext();
  const [formData, setFormData] = useState(initialState);
  const [selectedMgr, setSelectedMgr] = useState(initialUserDetail);

  useEffect(() => {
    const newUserName =
      formData.firstName.split(" ")[0] + "-" + formData.ievoCode;
    setFormData({
      ...formData,
      username: newUserName,
    });
  }, [formData.ievoCode, formData.firstName]);

  const handleChange = (event) => {
    if (formData) {
      setFormData({
        ...formData,
        [event.target.name]: event.target.value,
      });
    }
  };
  const handleSelectDept = (newValue) => {
    setFormData({
      ...formData,
      deptId: newValue?.id || 0,
    });
  };

  const handleAddNewUserSubmit = async (e) => {
    e.preventDefault();
    try {
      setFormData({ ...formData });
      setIsLoading(true);
      setOpenModal(false);
      const { data, status } = await addUserApi({
        ...formData,
        mgrUserId: selectedMgr?.userId || "",
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setIsReloadRequired(!isReloadRequired);
      setSuccess(data?.message);
      setFormData(initialState);
    } catch (error) {
      setError(error.message);
      setOpenModal(true);
    }
  };
  return (
    <>
      <FormModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        closeAfterTransition
      >
        <Paper className="formModal-class">
          <PageTitle pageName={pageName.admin.users.addUser} />
          <form onSubmit={handleAddNewUserSubmit}>
            <TextFieldWrapper
              id="username"
              name="username"
              label="Username"
              variant="outlined"
              value={formData.username}
              fullWidth
              required
              disabled
              onChange={handleChange}
            />
            <TextFieldWrapper
              id="ievoCode"
              name="ievoCode"
              label="ievoCode"
              variant="outlined"
              value={formData.ievoCode}
              type="number"
              slotProps={{
                input: { min: 0 },
              }}
              fullWidth
              required
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0 || e.target.value === "") {
                  handleChange(e);
                }
              }}
            />
            <TextFieldWrapper
              id="firstName"
              name="firstName"
              label="First Name"
              variant="outlined"
              value={formData.firstName}
              fullWidth
              required
              onChange={handleChange}
            />
            <TextFieldWrapper
              id="lastName"
              name="lastName"
              label="Last Name"
              variant="outlined"
              value={formData.lastName}
              fullWidth
              required
              onChange={handleChange}
            />
            <TextFieldWrapper
              id="email"
              name="email"
              type="email"
              label="Email"
              variant="outlined"
              value={formData.email}
              fullWidth
              required
              onChange={handleChange}
            />
            <TextFieldWrapper
              id="phoneNumber"
              name="phoneNumber"
              label="Phone Number"
              variant="outlined"
              value={formData.phoneNumber}
              fullWidth
              required
              onChange={handleChange}
            />
            <FormControlWrapper fullWidth>
              <DeptSelector
                handleDeptSelection={handleSelectDept}
                label="Department"
                selectedDept={formData.deptId}
              />
            </FormControlWrapper>

            <FormControlWrapper fullWidth>
              <SearchUsers
                label="Reporting Manager"
                handleUserSelection={setSelectedMgr}
                selectedUser={selectedMgr}
              />
            </FormControlWrapper>

            <Button variant="contained" type="submit" fullWidth>
              Add
            </Button>
          </form>
        </Paper>
      </FormModal>
    </>
  );
};
